/** Your team for each week's match, pasted from the teambuilder. Showdown checks it against your roster. */
import { getMatch, getOpponent } from '@ogreclan/league-core';
import { useEffect, useState } from 'preact/hooks';
import type { LeagueProps } from '../pages/league';
import { ActionButton } from '../ui';
import { playerName, you as findYou } from './common';

function WeekTeam({ week, saved, opponent, act }: { week: number, saved: string, opponent: string, act: LeagueProps['act'] }) {
	const [text, setText] = useState(saved);
	useEffect(() => setText(saved), [saved]);
	return <div class="card">
		<div class="row" style="justify-content:space-between">
			<h3 style="margin:0">Week {week}</h3>
			<span class="muted small">{opponent}</span>
		</div>
		<textarea rows={8} placeholder="Paste your team from the teambuilder (Export)" value={text}
			onInput={e => setText((e.target as HTMLTextAreaElement).value)} />
		<div class="row" style="margin-top:6px">
			<ActionButton class="primary small" disabled={!text.trim() || text === saved} action={() => act('saveteam', `${week}, ${text}`)}>
				Save
			</ActionButton>
			{saved && <ActionButton class="small danger" confirm={`Delete your week ${week} team?`} action={() => act('deleteteam', `${week}`)}>
				Delete
			</ActionButton>}
			{saved && <span class="badge good">Saved</span>}
		</div>
	</div>;
}

export function TeamsTab({ view, act }: LeagueProps) {
	const { league } = view;
	const me = findYou(league, view.you)!;
	return <>
		<p class="muted">Your team for each match. It's private: other players only see whether you've saved one. On match day,
			press Ready on Showdown and it's used for you.</p>
		<div class="grid">
			{league.schedule.map((_, i) => {
				const week = i + 1;
				const match = getMatch(league, week, me.id);
				const opponentId = match && getOpponent(match, me.id);
				const opponent = !match ? 'No match' : opponentId ? `vs ${playerName(league, opponentId)}` : 'Bye';
				return <WeekTeam key={week} week={week} saved={me.teams[week] || ''} opponent={opponent} act={act} />;
			})}
		</div>
	</>;
}
